import React from 'react';

import { SelectedFiltersWrapper } from '@/modules/CarsStock/components/common.styles';
import FilterTags from '@/components/FilterTags';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockBrandsAndModels,
} from '@/store/reducers/cars-stock';
import {
  convertSelectedFilterObjectToArray,
  handleDeleteAllFilters,
  handleDeleteSelectedFilterItem,
} from '@/modules/CarsStock/components/common.helpers';

function SelectedFilters() {
  const dispatch = useTypedDispatch();
  const brandsAndModels = useTypedSelector(getStockBrandsAndModels);
  const selectedFilters = useTypedSelector(getSelectedFilters);
  const selectedFiltersArray = convertSelectedFilterObjectToArray(
    selectedFilters,
    brandsAndModels
  );

  if (!selectedFiltersArray || selectedFiltersArray.length === 0) {
    return null;
  }

  return (
    <SelectedFiltersWrapper>
      <FilterTags
        selectedFilters={selectedFiltersArray}
        layout="desktop"
        useForStock
        handleDelete={(selectedItem) =>
          handleDeleteSelectedFilterItem(
            dispatch,
            selectedItem,
            selectedFilters
          )
        }
        handleDeleteAll={() =>
          handleDeleteAllFilters(dispatch, brandsAndModels)
        }
      />
    </SelectedFiltersWrapper>
  );
}

export default SelectedFilters;
